import { useLocale } from "@/i18n";

import { useAuthContextStore } from "@/features/auth/services/auth-context-store";
import { normalizeNotificationLanguage } from "@/features/notifications/lib/notification-language";
import { type NotificationLanguage } from "@/features/notifications/model/notifications.types";

export function useNotificationLanguage(): NotificationLanguage {
  const locale = useLocale();
  const activeWorkspaceSlug = useAuthContextStore((state) => state.activeWorkspaceSlug);
  const authMe = useAuthContextStore((state) => state.authMe);

  const userLanguage = normalizeNotificationLanguage(locale);
  if (userLanguage) return userLanguage;

  const currentWorkspaceLanguage = normalizeNotificationLanguage(
    authMe?.workspaceAccess.find((entry) => entry.workspace.slug === activeWorkspaceSlug)?.workspace.defaultLanguage,
  );
  if (currentWorkspaceLanguage) return currentWorkspaceLanguage;

  const fallbackWorkspaceLanguage = normalizeNotificationLanguage(authMe?.workspaceAccess[0]?.workspace.defaultLanguage);
  return fallbackWorkspaceLanguage ?? "fr";
}
